jQuery(($) => {
    $(window).scroll(() => {
        if ($(window).scrollTop() > 32) {
            $('.booom-transparent-header').addClass('booom-scrolled');
        } else {
            $('.booom-transparent-header').removeClass('booom-scrolled');
        }
    });
})